import { render, staticRenderFns } from "./PaperSection.vue?vue&type=template&id=04cda21a&"
import script from "./PaperSection.vue?vue&type=script&lang=js&"
export * from "./PaperSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports